import { handleJsonResponse } from "./generic";

function request(endpoint, method, body, successCallback, errorCallback) {
  fetch(endpoint, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((response) =>
    handleJsonResponse(response, successCallback, errorCallback)
  );
}

export function runCode(
  lessonId,
  code,
  screenIndex,
  successCallback,
  errorCallback
) {
  const body = {
    lesson_id: lessonId,
    code: code,
    custom_checker_id: screenIndex,
  };
  request("/api/run-code", "POST", body, successCallback, errorCallback);
}

export function getRunnerConnection(lessonId, successCallback, errorCallback) {
  const body = { lesson_id: lessonId };
  fetch("/api/get-runner-connection", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then(async (response) => {
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        successCallback(data);
      } else {
        errorCallback({
          ...data,
          status: response.status,
        });
      }
    })
    .catch((error) => errorCallback(error));
}

export function runScreenTest(screenTestId, successCallback, errorCallback) {
  const body = { screenTestId };
  request("/api/run-screen-test", "POST", body, successCallback, errorCallback);
}

export function resetRunnerSession(
  lessonId,
  successCallback = () => {},
  errorCallback = () => {}
) {
  fetch("/api/reset-runner-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ lesson_id: lessonId }),
  })
    .then(async (response) => {
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        successCallback(data);
      } else {
        errorCallback({
          ...data,
          status: response.status,
        });
      }
    })
    .catch((error) => errorCallback(error));
}
